import React from 'react';
import './MainPart.css';

function MainPart(){
    return(
        <div className='main-part'>
            <div className='main-details'>
                <h1 className='main-heading pt-1 pb-1'>Ultrabooks. Ultraportables.</h1>
                <p className='main-subheading pt-1 pb-3'>Shop the finest ultrabooks on the market!</p>
                <a className = 'main-button' href='#products'>Explore Laptops</a>
            </div>
        </div>
    )
}

export default MainPart;